import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { RegisterComponent } from "./components/RegisterComponent";
import { LoginComponent } from "./components/LoginComponent";
import { InventoryComponent } from "./components/InventoryComponent";
import { EasterEggComponent } from "./components/EasterEggComponent";
import { ClockPuzzleComponent } from "./components/ClockPuzzleComponent";
import { InputfieldComponent } from "./components/InputfieldComponent";
import { WereldmapComponent } from "./components/WereldmapComponent";
import { NotebookComponent } from "./components/NotebookComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("game-notebook", NotebookComponent);
window.customElements.define("register-component", RegisterComponent);
window.customElements.define("login-component", LoginComponent);
window.customElements.define("game-inventory", InventoryComponent);
window.customElements.define("game-easteregg", EasterEggComponent);
window.customElements.define("game-input", InputfieldComponent);
window.customElements.define("game-clock", ClockPuzzleComponent);
window.customElements.define("game-wereldmap", WereldmapComponent);
